import { PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import { CloseButton, InnerPopUp, Overlay, PopUpView } from './PopUp.styles';

export type Props = PropsWithChildren<{
  darkOverlay?: boolean;
  modal?: boolean;
  onClose?: () => unknown;
  showing?: boolean;
}>;

export const PopUp = ({
  children,
  darkOverlay = true,
  modal = false,
  onClose,
  showing = false,
}: Props) => {
  const handleBackdropClick = () => {
    if (!modal) onClose?.();
  };

  return (
    <PopUpView showing={showing}>
      <CSSTransition in={showing} unmountOnExit timeout={200}>
        <Overlay darkOverlay={darkOverlay} onClick={handleBackdropClick} />
      </CSSTransition>

      <CSSTransition in={showing} unmountOnExit timeout={200}>
        <InnerPopUp>
          {!modal && <CloseButton onClick={onClose} />}
          {children || <LoadingSpinner />}
        </InnerPopUp>
      </CSSTransition>
    </PopUpView>
  );
};
